import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { Button } from "@/Components/ui/button";
import PropTypes from 'prop-types';
import icon1 from '../../images/allergens/1.webp';
import icon3 from '../../images/allergens/3.webp';
import icon4 from '../../images/allergens/4.webp';
import icon5 from '../../images/allergens/5.webp';
import icon11 from '../../images/allergens/11.webp';
import icon12 from '../../images/allergens/12.webp';
import icon16 from '../../images/allergens/16.webp';
import icon17 from '../../images/allergens/17.webp';
import icon19 from '../../images/allergens/19.webp';
import icon21 from '../../images/allergens/21.webp';
import icon22 from '../../images/allergens/22.webp';
import icon23 from '../../images/allergens/23.webp';
import icon24 from '../../images/allergens/24.webp';
import icon26 from '../../images/allergens/26.webp'; 

const ALLERGENS = [
    { id: 5, name: "Gluten", icon: icon5 },
    { id: 12, name: "Schaaldieren", icon: icon12 },
    { id: 3, name: "Ei", icon: icon3 },
    { id: 11, name: "Vis", icon: icon11 },
    { id: 17, name: "Pinda's", icon: icon17 },
    { id: 4, name: "Soja", icon: icon4 },
    { id: 1, name: "Melk", icon: icon1 },
    { id: 16, name: "Noten", icon: icon16 },
    { id: 21, name: "Selderij", icon: icon21 },
    { id: 24, name: "Mosterd", icon: icon24 },
    { id: 22, name: "Sesam", icon: icon22 },
    { id: 19, name: "Sulfiet", icon: icon19 },
    { id: 23, name: "Lupine", icon: icon23 },
    { id: 26, name: "Weekdieren", icon: icon26 }
];


const AllergenDisplay = ({ allergen }) => {
    const { t } = useTranslation();

    const allergenName = t(`allergens.${allergen.id}`, 'Onbekend allergeen');

    return (
    <span className="font-inter">{allergenName}</span>
    );
};

const AllergensModal = ({ isOpen, onClose, onSave, selectedAllergens = [] }) => {
    const { t } = useTranslation();
    const [selected, setSelected] = React.useState(selectedAllergens);

    useEffect(() => {
        setSelected(selectedAllergens);
    }, [selectedAllergens]);

    const handleToggle = (allergen) => {
        setSelected(prev =>
            prev.find(item => item.id === allergen.id)
                ? prev.filter(item => item.id !== allergen.id)
                : [...prev, allergen]
        );
    };

    const handleSave = () => {
        onSave(selected);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
            <div className="bg-white rounded-lg w-full max-w-md p-2 relative">
                <button
                    onClick={onClose}
                    className="absolute right-4 top-4 text-gray-500 hover:text-gray-700"
                >
                    <X size={24} />
                </button>

                <h2 className="text-xl font-inter text-ps-blue-dark mb-4">
                    {t('modals.selectAllergens')}
                </h2>

                <div className="space-y-2 mb-6">
                    {ALLERGENS.map((allergen) => (
                        <div
                            key={allergen.id}
                            className="flex items-center gap-3 p-1 cursor-pointer "
                            onClick={() => handleToggle(allergen)}
                        >
                            <input
                                type="checkbox"
                                checked={selected.some(item => item.id === allergen.id)}
                                readOnly
                                className="w-4 h-4"
                            />
                            <img
                                src={allergen.icon}
                                alt={allergen.name}
                                className="w-6 h-6"
                            />
                            <AllergenDisplay allergen={allergen} />
                        </div>
                    ))}
                </div>

                <div className="flex justify-end gap-4">
                    <Button
                        onClick={handleSave}
                        className="bg-ps-green  w-40 hover:bg-ps-green/90 text-white font-inter"
                    >
                        {t('common.add')}
                    </Button>
                </div>
            </div>
        </div>
    );
};

AllergensModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    selectedAllergens: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string
        })
    )
};

export default AllergensModal;